import { Navigate, useOutletContext } from 'react-router-dom';

/**
 * Operators only (the fleet pages). Anyone else goes to "/", the landing
 * rule. UX only: the API refuses them on its own too.
 */
export default function RequireOperator({ children }) {
  const { navClaims } = useOutletContext();
  return navClaims?.isOperator === true ? children : <Navigate to="/" replace />;
}
